import fetchRequest from '../../helpers/fetchRequest';

export async function getLatestPodcasts(year, month, program, limit, offset) {
  const url = '/latest-podcasts';
  const options = {
    method: 'POST',
    body: JSON.stringify({
      year: year,
      month: month,
      program: program,
      limit: limit,
      offset: offset,
    }),
    headers: { 'Content-Type': 'application/json' },
  };
  return fetchRequest(url, options);
}

export async function getPlaylistChart() {
  const url = '/charts/playlist';
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  return fetchRequest(url, options);
}

export async function getNoveltyChart() {
  const url = '/charts/novelty';
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  return fetchRequest(url, options);
}

export async function getCurrentBanner() {
  const url = '/current-banner';
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  return fetchRequest(url, options);
}

export async function getLatestNews() {
  const url = '/latest-news';
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  return fetchRequest(url, options);
}

export async function getChartTimestamp() {
  const url = `/get-chart-timestamp`;
  const options = {
    method: 'GET',
  };
  return fetchRequest(url, options);
}

export async function getPodcastsAmount(year, month, program) {
  const url = `/get-podcasts-amount`;
  const options = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      year: year,
      month: month,
      program: program,
    }),
  };
  return fetchRequest(url, options);
}